<template>
  <van-col span="24">
    <van-cell :title="$t('column.select_date_range')" :value="date" @click="show = true"/>
    <van-calendar color="#887BFF" v-model="show" type="range" @confirm="onConfirm"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :confirm-text="$t('btn.confirm')"
                  :formatter="formatter"/>
    <van-cell :title="$t('other.general_statistics')" :value="total_num"/>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-tabs @click="onClickTabs" color="#887BFF" v-model="active">
        <van-tab :title="$t('column.gift_collection_record')">
          <van-list
            v-model="gift_loading"
            :finished="gift_finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
            @load="onLoadGift"
          >
            <van-cell v-for="(item,k) in gift_list" :key="k" :title="item.create_time" :label="item.nick_name+ $t('other.give') +item.prop_name"
                      :value="'+'+item.total_ticket"/>
          </van-list>
        </van-tab>
        <van-tab :title="$t('column.guardian_record')">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
            @load="onLoadGuradRecord"
          >
            <van-cell v-for="(item,k) in list"  :key="k"  :title="item.log_time" :label="item.nick_name+ $t('column.open_guard')"
                      :value="'+'+item.ticket"/>
          </van-list>
        </van-tab>
      </van-tabs>
    </van-pull-refresh>
  </van-col>

</template>
<script>
    import axios from 'axios'
    import Toast from "vant/lib/toast"
    export default {
        data() {
            return {
                list: [],
                gift_list: [],
                loading: false,
                finished: false,
                gift_loading: false,
                gift_finished: false,
                gift_page: 0,
                page: 0,
                page_size: 0,
                show: false,
                isLoading: false,
                date: '',
                minDate: new Date(2019, 0, 1),
                maxDate: new Date(2030, 0, 31),
                guard_total_num: 0,
                gift_total_num: 0,
                active: 0,
                gift_start_time: '',
                gift_end_time: '',
                guard_start_time: '',
                guard_end_time: '',
                total_num: 0,
            };
        },
        created: function () {
            document.title = this.$t('title.emcee_income_log');
            this.date = this.$t('column.default_month');
        },
        methods: {
            formatter(day) {
                const month = day.date.getMonth() + 1
                const date = day.date.getDate()
              /*
                if (day.type === 'start') {
                  day.bottomInfo = '入住2'
                } else if (day.type === 'end') {
                  day.bottomInfo = '离店3'
                }*/
                return day
            },
            formatDate(date) {
                return `${date.getMonth() + 1} ` + this.$t('other.month') +`${date.getDate()}` + this.$t('other.day');
            },
            onConfirm(date) {
                const [start, end] = date;
                if (start.getMonth() !== end.getMonth()) {
                    Toast(this.$t('Tips.cannot_cross_month_query'));
                    this.show = false;
                    return;
                }
                this.show = false;
                this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;

                var startTime = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate();
                var endTime = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate();

                //选择更改礼物列表日期
                if (this.active === 0) {
                    this.gift_page = 0;
                    this.gift_start_time = startTime;
                    this.gift_end_time = endTime;
                    this.onLoadGift();
                } else if (this.active === 1) {
                    this.page = 0;
                    this.guard_start_time = startTime;
                    this.guard_end_time = endTime;
                    this.onLoadGuradRecord();
                }
            },
            onClickTabs() {
                if (this.active === 0) {
                    this.total_num = this.gift_total_num;
                } else if (this.active === 1) {
                    this.total_num = this.guard_total_num;
                }
            },
            onRefresh() {
                if (this.active === 0) {
                    this.gift_page = 0;
                    this.onLoadGift();
                } else if (this.active === 1) {
                    this.page = 0;
                    this.onLoadGuradRecord();
                }
            },
            //请求礼物收益记录
            onLoadGift() {
                this.gift_page++;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=emcee_center&act=get_emcee_gift_income_record", {
                    params: {
                        token: token,
                        page: this.gift_page,
                        start_time: this.gift_start_time,
                        end_time: this.gift_end_time,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        this.gift_finished = true;
                        return;
                    }
                    if (this.gift_page === 1) {
                        this.gift_list = res.data.list;
                    } else {
                        this.gift_list = this.gift_list.concat(res.data.list)
                    }
                    this.gift_total_num = res.data.total_num;
                    if (this.active === 0) {
                        this.total_num = this.gift_total_num;
                    }

                    // 加载状态结束
                    this.gift_loading = false;

                    //数据全部加载完成
                    if (res.data.list.length < 50) {
                        this.gift_finished = true;
                    } else {
                        this.gift_finished = false;
                    }

                    this.isLoading = false;
                });
            },
            //请求守护收益记录
            onLoadGuradRecord: function () {
                this.page++;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=emcee_center&act=get_emcee_guard_income_record", {
                    params: {
                        token: token,
                        page: this.page,
                        start_time: this.guard_start_time,
                        end_time: this.guard_end_time,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        this.finished = true;
                        return;
                    }
                    if (this.page === 1) {
                        this.list = res.data.list;
                    } else {
                        this.list = this.list.concat(res.data.list)
                    }
                    this.guard_total_num = res.data.total_num;
                    if (this.active === 1) {
                        this.total_num = this.guard_total_num;
                    }

                    // 加载状态结束
                    this.loading = false;

                    //数据全部加载完成
                    if (res.data.list.length < 50) {
                        this.finished = true;
                    } else {
                        this.gift_finished = false;
                    }
                    this.isLoading = false;
                })
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/emcee_income_log.vue